// Translation: Error > Landing > Message (German)
export default Object.freeze({
	fallback: {
		title: ''
	}
})
